import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import appstore from './redux/store/appstore';

const root = ReactDOM.createRoot(document.getElementById("root"));

const platform = process.env.REACT_APP_LC_PLATFORM;

console.log("platform = ", platform);

if (platform == "local") {
  console.log = () => { };
  console.debug = () => { };
  console.info = () => { };
}

root.render(
  <Provider store={appstore}>
    <React.Fragment>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();